module.exports = __webpack_public_path__ + "static/img/img-background-4.57b2ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-4.png
// module id = TTrC
// module chunks = 36